// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__SNe3A","modalInner":"modal_modalInner__0EFsb","buttonClose":"modal_buttonClose__V45EO"};